module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "content_title"
  }, [(_vm.catedetailDataArr.extra_data && _vm.catedetailDataArr.extra_data.length > 0) ? [_c('p', [_vm._v(_vm._s(_vm.catedetailDataArr.extra_data[1].field_key == 'career' ? _vm.catedetailDataArr.extra_data[1].value + ' :' : ''))]), _vm._v("\n              \n          "), _c('p', [_vm._v(_vm._s(_vm.catedetailDataArr.extra_data[0].field_key == 'name' ? _vm.catedetailDataArr.extra_data[0].value : 'Nothing'))])] : [_vm._v("\n          " + _vm._s(_vm.catedetailDataArr.title) + "\n      ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "content_date"
  }, [_vm._v("\n    发布日期：" + _vm._s(_vm._f("timeFormat")(_vm.catedetailDataArr.create_time)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content_container html-data",
    domProps: {
      "innerHTML": _vm._s(_vm.catedetailDataArr.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-340e257e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/ContentSinglePage.vue
// module id = 1194
// module chunks = 0